import React, { useEffect } from "react";
import Gigantic from "../headers/Gigantic";
import CEOImage from "../../assets/images/img/Mahmud.png";
import DGImage from "../../assets/images/img/saminu.png";
import SGImage from "../../assets/images/img/Haruna.jpg";
import Director1 from "../../assets/images/img/Barr.png";
import Director2 from "../../assets/images/img/Hajiya.jpg";
import TopBtn from "../buttons/TopBtn";

const About = () => {
  const firstObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      const aboutIcon1 = entry.target.querySelector(".about-item1 .fa");
      const aboutHeader1 = entry.target.querySelector(".about-item1 h3");
      const aboutParagraph1 = entry.target.querySelector(".about-item1 p");

      if (entry.isIntersecting) {
        aboutIcon1.classList.add("about-anim1-1");
        aboutHeader1.classList.add("about-anim1-2");
        aboutParagraph1.classList.add("about-anim1-3");

        return;
      }

      aboutIcon1.classList.remove("about-anim1-1");
      aboutHeader1.classList.remove("about-anim1-2");
      aboutParagraph1.classList.remove("about-anim1-3");
    });
  });

  const secondObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      const aboutIcon2 = entry.target.querySelector(".about-item2 .fa");
      const aboutHeader2 = entry.target.querySelector(".about-item2 h3");
      const aboutParagraph2 = entry.target.querySelector(".about-item2 p");

      if (entry.isIntersecting) {
        aboutIcon2.classList.add("about-anim1-1");
        aboutHeader2.classList.add("about-anim1-2");
        aboutParagraph2.classList.add("about-anim1-3");
        return;
      }

      aboutIcon2.classList.remove("about-anim1-1");
      aboutHeader2.classList.remove("about-anim1-2");
      aboutParagraph2.classList.remove("about-anim1-3");
    });
  });

  const thirdObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      const aboutIcon3 = entry.target.querySelector(".about-item3 .fa");
      const aboutHeader3 = entry.target.querySelector(".about-item3 h3");
      const aboutParagraph3 = entry.target.querySelector(".about-item3 p");

      if (entry.isIntersecting) {
        aboutIcon3.classList.add("about-anim1-1");
        aboutHeader3.classList.add("about-anim1-2");
        aboutParagraph3.classList.add("about-anim1-3");
        return;
      }

      aboutIcon3.classList.remove("about-anim1-1");
      aboutHeader3.classList.remove("about-anim1-2");
      aboutParagraph3.classList.remove("about-anim1-3");
    });
  });

  const imageObserver1 = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      const leadersImage = entry.target.querySelector(".leaders-image");
      const leadersTitle = entry.target.querySelector(".leaders-title");
      const leadersParagraph = entry.target.querySelector(".leaders-p");

      if (entry.isIntersecting) {
        leadersImage.classList.add("leaders-image-anim");
        leadersTitle.classList.add("leaders-anim1");
        leadersParagraph.classList.add("leaders-anim1-2");

        return;
      }

      leadersImage.classList.remove("leaders-image-anim");
      leadersTitle.classList.remove("leaders-anim1");
      leadersParagraph.classList.remove("leaders-anim1-2");
    });
  });
  const imageObserver2 = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      const leadersImage = entry.target.querySelector(".leaders-image");
      const leadersTitle = entry.target.querySelector(".leaders-title");
      const leadersParagraph = entry.target.querySelector(".leaders-p");

      if (entry.isIntersecting) {
        leadersImage.classList.add("leaders-image-anim");
        leadersTitle.classList.add("leaders-anim1");
        leadersParagraph.classList.add("leaders-anim1-3");

        return;
      }

      leadersImage.classList.remove("leaders-image-anim");
      leadersTitle.classList.remove("leaders-anim1");
      leadersParagraph.classList.remove("leaders-anim1-3");
    });
  });

  const imageObserver3 = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      const leadersImage = entry.target.querySelector(".leaders-image");
      const leadersTitle = entry.target.querySelector(".leaders-title");
      const leadersParagraph = entry.target.querySelector(".leaders-p");

      if (entry.isIntersecting) {
        leadersImage.classList.add("leaders-image-anim");
        leadersTitle.classList.add("leaders-anim1");
        leadersParagraph.classList.add("leaders-anim1-3");

        return;
      }

      leadersImage.classList.remove("leaders-image-anim");
      leadersTitle.classList.remove("leaders-anim1");
      leadersParagraph.classList.remove("leaders-anim1-3");
    });
  });

  const imageObserver4 = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      const leadersImage = entry.target.querySelector(".leaders-image");
      const leadersTitle = entry.target.querySelector(".leaders-title");
      const leadersParagraph = entry.target.querySelector(".leaders-p");

      if (entry.isIntersecting) {
        leadersImage.classList.add("leaders-image-anim");
        leadersTitle.classList.add("leaders-anim1");
        leadersParagraph.classList.add("leaders-anim1-3");

        return;
      }

      leadersImage.classList.remove("leaders-image-anim");
      leadersTitle.classList.remove("leaders-anim1");
      leadersParagraph.classList.remove("leaders-anim1-3");
    });
  });
  const imageObserver5 = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      const leadersImage = entry.target.querySelector(".leaders-image");
      const leadersTitle = entry.target.querySelector(".leaders-title");
      const leadersParagraph = entry.target.querySelector(".leaders-p");

      if (entry.isIntersecting) {
        leadersImage.classList.add("leaders-image-anim");
        leadersTitle.classList.add("leaders-anim1");
        leadersParagraph.classList.add("leaders-anim1-3");

        return;
      }

      leadersImage.classList.remove("leaders-image-anim");
      leadersTitle.classList.remove("leaders-anim1");
      leadersParagraph.classList.remove("leaders-anim1-3");
    });
  });

  
  useEffect(() => {
    firstObserver.observe(document.querySelector(".about-item1"));
    secondObserver.observe(document.querySelector(".about-item2"));
    thirdObserver.observe(document.querySelector(".about-item3"));
    imageObserver1.observe(document.querySelector(".leaders-item-center "));
    imageObserver2.observe(document.querySelector(".leaders-item1 "));
    imageObserver3.observe(document.querySelector(".leaders-item2 "));
    imageObserver4.observe(document.querySelector(".leaders-item3 "));
    imageObserver5.observe(document.querySelector(".leaders-item4 "));
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    return () => {};
  }, []);

  return (
    <div className="page-container">
      <div className="container">
        <div className="">
          <div className="" id="about">
            <div className="about-item1">
              <div className="">
                <div className="box highlight">
                  <i className="fa fa-bullseye"></i>
                  <div className="inner">
                    <h3>Our Mission</h3>
                    <p>
                      We offer goods and services to employees and we wait until
                      they get their salary.{" "}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="about-item2">
              <div className="">
                <i className="fa fa-history"></i>
                <div className="inner">
                  <h3>Our Story</h3>
                  <p>
                    We started in 2019, We enhanced thousands of employees
                    lives.
                  </p>
                </div>
              </div>
            </div>
            <div className="about-item3">
              <div className="">
                <div className="box highlight">
                  <i className="fa fa-eye"></i>
                  <div className="inner">
                    <h3>Our Vision</h3>
                    <p>
                      We glanced as the best organization ever that cares with
                      employee's welfare.{" "}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div id="leadership">
          <Gigantic headerTitle="Our Leadership" />
          <div className="leaders-item-center">
            <section>
              <img src={CEOImage} alt="" className="leaders-image" />
              <div className="">
                <span>
                  {" "}
                  <p className="leaders-title">
                    {" "}
                    Mahmud Jibril
                    <br />
                    Founder/Developer{" "}
                  </p>
                </span>
                <p className="leaders-p">
                  Born in Kano State of Nigeria, A software developer, Founder;
                  M.J Usman ICT Company Ltd.
                </p>
                <p></p>
              </div>
            </section>
          </div>
          <div className="leaders-wrapper">
            <section className="leaders-item1">
              <div className="">
                <a href="#" className="">
                  <img src={Director1} alt="" className="leaders-image" />
                </a>
                <div className="">
                  <span>
                    <p className="leaders-title">
                      Salisu Abdullahi Marmara <br /> Director Legal
                    </p>
                  </span>
                  <p className="leaders-p">
                    Born in Kano State Nigeria; a corporate legal practitioner
                    and an entrepreneur, acted as a legal advisor/ secretary to
                    the Kano State Internal Revenue Service.
                  </p>
                </div>
              </div>
            </section>

            <section className="leaders-item2">
              <div className="">
                <a href="#" className="">
                  <img src={DGImage} alt="" className="leaders-image" />
                </a>
                <div className="">
                  <span>
                    <p className="leaders-title">
                      Saminu Garba Idris <br /> Secretary
                    </p>
                  </span>
                  <p className="leaders-p">
                    {" "}
                    A special chemist and an entrepreneur interested in ICT and
                    corporate management. A Director M.J Usman ICT Company Ltd.,
                    A secretary Good Citizens Association of Nigeria.
                  </p>
                  <p></p>
                </div>
              </div>
            </section>
            <section className="leaders-item3">
              <img src={SGImage} alt="" className="leaders-image" />

              <div className="">
                <span>
                  <p className="leaders-title">
                    Haruna Abdulkadir Dangambo <br /> Managing Director
                  </p>
                </span>
                <p className="leaders-p">
                  An industrial chemist with entrepreneurial skills, interested
                  in ICT and corporate management, The Managing Director M.J
                  Usman Natural Healthy Foods Ltd.
                </p>
                <p></p>
              </div>
            </section>
            <section className="leaders-item4">
              <div className="">
                <a href="#" className="">
                  <img src={Director2} alt="" className="leaders-image" />
                </a>
                <div className="">
                  <span>
                    <p className="leaders-title">
                      A'ishatu Isa Ma'aji <br /> Director HR
                    </p>
                  </span>
                  <p className="leaders-p">
                    {" "}
                    A former Director, College Entrepreneurship Development and
                    Research, A former HOD, Department of primary education
                    studies SRCOE Kumbotso, Kano
                  </p>
                  <p></p>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
      <TopBtn />
    </div>
  );
};

export default About;
